// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"fb0e4256","439":"4e137388","453":"14cb9627","742":"461e6ff1","778":"ec77cf88","981":"b3d59811"}[chunkId] + ".chunk.js";
};